"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            submitting: false,
            showPosterPlus: false,
            suggestions: []
        };
        fhandler.bind(this);
    },
    onMount: function () {
        const title = 'Create Department';
        fhandler.on('autosave', () => GState.activity.add({
            title,
            path: '/create-department'
        })).on('reset', () => GState.activity.remove(title));
    },
    onSelectPoster: function (status) {
        this.state.showPosterPlus = status || false;
    },
    onSetPoster: function ({base64, src}) {
        if (!src)
            return;
        fhandler.set('poster', base64 || src);
        this.state.showPosterPlus = false;
    },
    onSearchResult: function (results) {
        this.state.suggestions = results.map(({profile, account}) => {
            return {
                poster: {
                    type: 'image',
                    value: profile.photo
                },
                title: getFullname(profile),
                subtitle: profile.email,
                status: (account.roles || []).filter(role => {
                    return role != 'USER';
                }).join(', ')
            };
        });
    },
    onSearchDismiss: function () {
        this.state.suggestions = [];
    },
    onSelectSuggestion: function (index) {
        fhandler.set('manager', this.state.suggestions[index].subtitle);
        this.onSearchDismiss();
    },
    onSubmit: async function () {
        const Form = this.state.form;
        if (!Form.name)
            return this.state.formError.name = true;
        if (!Form.description)
            return this.state.formError.description = true;
        this.state.submitting = true;
        try {
            const {error, message, departmentId} = await Request('/department/create', 'POST', Form);
            this.state.submitting = false;
            fhandler.alert(message, error ? 'error' : 'success');
            if (error)
                return;
            fhandler.reset();
            setTimeout(() => navigate(`/department/${ departmentId }`), 3000);
        } catch (error) {
            this.state.submitting = false;
            fhandler.alert(error);
        }
    },
    onReset: function () {
        fhandler.reset();
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Departments/Create.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_FormHandler = require("markojs-form"),
    FormHandler = module_FormHandler.default || module_FormHandler,
    PosterInput_template = require("../../components/PosterInput.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    PosterInput_tag = marko_loadTag(PosterInput_template),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    Locale_template = require("../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    SearchBar_template = require("../../../components/SearchBar/index.marko"),
    SearchBar_tag = marko_loadTag(SearchBar_template),
    FormAlert_template = require("../../../components/FormAlert/index.marko"),
    FormAlert_tag = marko_loadTag(FormAlert_template),
    Preloader_template = require("../../../components/Preloader/index.marko"),
    Preloader_tag = marko_loadTag(Preloader_template),
    WSAdapt_template = require("../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    PosterPlus_template = require("../../../components/PosterPlus/index.marko"),
    PosterPlus_tag = marko_loadTag(PosterPlus_template),
    Wrapper_Admin_template = require("../../components/Wrapper-Admin.marko"),
    Wrapper_Admin_tag = marko_loadTag(Wrapper_Admin_template),
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("13ff69"),
    marko_node0 = marko_createElement("br", null, "6", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "7", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs0 = {
        "class": "form-group"
      },
    marko_attrs1 = {
        "class": "form-group"
      },
    marko_attrs2 = {
        "class": "form-group"
      },
    marko_node2 = marko_createElement("br", null, "17", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "col-md-4 col-5 p-0"
      },
    marko_node3 = marko_createElement("div", {
        "class": "col-md-8 col-7 pl-6"
      }, "5", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs4 = {
        "class": "col-4 pr-50"
      },
    marko_attrs5 = {
        "class": "col pl-50"
      },
    marko_attrs6 = {
        type: "reset",
        "class": "btn btn-light btn-xl w-100"
      };

const fhandler = new FormHandler({ key: 'create-department', autosave: true });

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_Admin_tag({
      class: "d-flex justify-content-center",
      renderBody: function(out, { page, themeMode }) {
        WSAdapt_tag({
            qs: "col-xl-6",
            hs: "col-xl-9",
            class: "col-xl-5 col-lg-7 col-md-10",
            renderBody: function(out) {
              out.be("form", null, "@create-department", component);

              Row_tag({
                  class: "m-0 d-flex align-items-center",
                  renderBody: function(out) {
                    out.be("div", marko_attrs3, "3", component);

                    PosterInput_tag({
                        src: state.form.poster,
                        style: "height:12rem",
                        btn: Locale((state.editing ? "Edit" : "Add") + " Image")
                      }, out, __component, "4", [
                      [
                        "click",
                        "onSelectPoster",
                        false,
                        [
                            true
                          ]
                      ]
                    ]);

                    out.ee();

                    out.n(marko_node3, component);
                  }
                }, out, __component, "2");

              out.n(marko_node0, component);

              out.n(marko_node1, component);

              out.be("div", null, "8", component);

              out.be("div", marko_attrs0, "9", component);

              out.e("input", {
                  type: "text",
                  value: state.form.name,
                  name: "name",
                  "class": marko_classValue("form-control form-control-xl pl-4" + (state.formError.name != undefined ? state.formError.name ? " is-invalid" : " is-valid" : "")),
                  validate: "required",
                  placeholder: Locale("Name of the department")
                }, "10", component, 0, 0, {
                  onchange: __component.d("change", "__onChange", false)
                });

              out.be("p", {
                  "class": marko_classValue("small mt-50 mb-2" + (!state.formError.name ? " d-none" : ""))
                }, "11", component, null, 1);

              Locale_tag({
                  text: "Department name is required"
                }, out, __component, "12");

              out.ee();

              out.ee();

              out.e("div", marko_attrs1, "13", component, 1)
                .e("textarea", {
                    type: "text",
                    value: state.form.description,
                    required: true,
                    name: "description",
                    "class": marko_classValue("form-control form-control-xl pl-4 " + (state.formError.description != null ? state.formError.description ? " is-invalid" : " is-valid" : "")),
                    placeholder: Locale("Description"),
                    style: marko_styleValue({
                        height: "100px",
                        resize: "none"
                      })
                  }, "14", component, 0, 0, {
                    onchange: __component.d("change", "__onChange", false)
                  });

              out.be("div", marko_attrs2, "15", component);

              SearchBar_tag({
                  size: "xl",
                  icon: "bx-user",
                  target: "user",
                  minLength: 3,
                  suggestions: state.suggestions,
                  placeholder: Locale("Add a manager")
                }, out, __component, "16", [
                [
                  "blur",
                  "onSearchDismiss",
                  false
                ],
                [
                  "result",
                  "onSearchResult",
                  false
                ],
                [
                  "select",
                  "onSelectSuggestion",
                  false
                ]
              ]);

              out.ee();

              out.n(marko_node2, component);

              FormAlert_tag({
                  alert: state.alert
                }, out, __component, "18");

              Row_tag({
                  renderBody: function(out) {
                    out.e("div", marko_attrs4, "20", component, 1)
                      .e("button", marko_attrs6, "21", component, 1, 0, {
                          onclick: __component.d("click", "onReset", false)
                        })
                        .t("Reset");

                    out.be("div", marko_attrs5, "22", component);

                    out.be("button", {
                        type: "submit",
                        "class": "btn btn-primary btn-xl w-100",
                        disabled: state.submitting
                      }, "23", component, null, 0, {
                        onclick: __component.d("click", "onSubmit", false)
                      });

                    Preloader_tag({
                        class: "float-right font-medium-5",
                        active: state.submitting
                      }, out, __component, "24");

                    Locale_tag({
                        text: "Save"
                      }, out, __component, "25");

                    out.ee();

                    out.ee();
                  }
                }, out, __component, "19");

              out.ee();

              out.ee();
            }
          }, out, __component, "1");

        if (state.showPosterPlus == true) {
          PosterPlus_tag({
              cdn: "department",
              width: 280,
              height: 280,
              maxSize: 1024,
              accepts: "image/*",
              theme: themeMode
            }, out, __component, "26", [
            [
              "done",
              "onSetPoster",
              false
            ],
            [
              "cancelled",
              "onSelectPoster",
              false,
              [
                  false
                ]
            ]
          ]);
        }
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
